import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'wouter';
import ParallaxBackground from '../components/ParallaxBackground';
import Footer from '../components/Footer';
import '../styles/cinematic.css';

const Memories = () => {
    const [_, setLocation] = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Load images dynamically from optimized assets
    const memories = useMemo(() => {
        // Updated to point to optimized webp folder or just load as webp 
        // Since we generated them in src/assets/photos_opt, we need to import from there
        // OR we can just change the glob to look for .webp in the new folder
        const images = import.meta.glob('../assets/photos_opt/*.webp', { eager: true });

        return Object.values(images).map((img, i) => ({
            id: i,
            src: img.default,
            caption: `Memory #${i + 1}`,
            rotation: Math.random() * 10 - 5,
            scale: 0.9 + Math.random() * 0.2
        }));
    }, []);

    return (
        <div style={{
            width: '100vw',
            minHeight: '100vh',
            position: 'relative',
            overflowX: 'hidden',
            fontFamily: "'Rajdhani', sans-serif"
        }}>
            {/* Reusing the Cinematic Background */}
            <ParallaxBackground />

            {/* Content Wrapper */}
            <div style={{
                position: 'relative',
                zIndex: 10,
                width: '100%',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                paddingBottom: '100px'
            }}>
                {/* Header with Carnival Vibe */}
                <div style={{
                    marginTop: '60px',
                    textAlign: 'center',
                    textShadow: '0 0 20px #FF0095'
                }}>
                    <h1 className="neon-text-pink flicker-slow" style={{
                        fontSize: 'clamp(3rem, 6vw, 5rem)',
                        fontFamily: 'Orbitron',
                        marginBottom: '10px',
                        transform: 'rotate(-2deg)'
                    }}>
                        MEMORIES
                    </h1>
                    <div style={{
                        display: 'inline-block',
                        background: '#00F5FF',
                        color: '#000',
                        padding: '5px 20px',
                        transform: 'rotate(1deg)',
                        fontWeight: 'bold',
                        fontFamily: 'Orbitron',
                        letterSpacing: '2px',
                        boxShadow: '0 0 15px #00F5FF'
                    }}>
                        REWIND THE FUN
                    </div>
                </div>

                {/* Scrapbook Gallery */}
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: '40px', // More spacing for scattered look
                    padding: '60px 20px',
                    maxWidth: '1400px'
                }}>
                    {memories.map((img, index) => (
                        <div key={img.id} className="memory-card" style={{
                            position: 'relative',
                            width: '300px',
                            maxWidth: '100%', // Ensure it fits on small screens
                            height: '240px',
                            background: 'rgba(255, 255, 255, 0.05)',
                            backdropFilter: 'blur(10px)',
                            border: '1px solid rgba(0, 245, 255, 0.3)',
                            padding: '10px',
                            boxShadow: '0 0 15px rgba(0, 245, 255, 0.2)',
                            transform: `rotate(${img.rotation}deg) scale(${img.scale})`,
                            transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.27)',
                            cursor: 'pointer',
                            zIndex: 1
                        }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'scale(1.1) rotate(0deg)';
                                e.currentTarget.style.zIndex = 100;
                                e.currentTarget.style.boxShadow = '0 0 40px rgba(0, 245, 255, 0.6), 0 0 20px rgba(255, 0, 149, 0.4)';
                                e.currentTarget.style.border = '1px solid rgba(255, 255, 255, 0.8)';
                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = `rotate(${img.rotation}deg) scale(${img.scale})`;
                                e.currentTarget.style.zIndex = 1;
                                e.currentTarget.style.boxShadow = '0 0 15px rgba(0, 245, 255, 0.2)';
                                e.currentTarget.style.border = '1px solid rgba(0, 245, 255, 0.3)';
                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                            }}
                        >
                            {/* Tape Effect */}
                            <div style={{
                                position: 'absolute',
                                top: '-15px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: '100px',
                                height: '25px',
                                background: 'rgba(255, 255, 255, 0.2)',
                                border: '1px solid rgba(255,255,255,0.2)',
                                boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                zIndex: 10,
                                backdropFilter: 'blur(5px)'
                            }} />

                            <div style={{
                                width: '100%',
                                height: '100%',
                                overflow: 'hidden',
                                borderRadius: '4px'
                            }}>
                                <img
                                    src={img.src}
                                    alt={img.caption}
                                    loading="lazy"
                                    decoding="async"
                                    width="800"
                                    height="600"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        filter: 'sepia(0.2) contrast(1.1)'
                                    }}
                                />
                            </div>
                        </div>
                    ))}
                </div>

                {memories.length === 0 && (
                    <div style={{
                        textAlign: 'center',
                        color: 'rgba(255, 255, 255, 0.6)',
                        fontFamily: 'Orbitron',
                        marginTop: '20px'
                    }}>
                        <p>No memories found available in assets/photos</p>
                    </div>
                )}



            </div>
            <Footer />
        </div>
    );
};

export default Memories;
